// extracted by mini-css-extract-plugin
export default {"container":"noBdV4X7gFKSfxwiBqQ0","label":"KAipudddKdnc_Wt3fa52"};